import React, { useEffect, useState } from 'react';
import { applyUpdate, UPDATE_AVAILABLE_EVENT } from '../serviceWorkerRegistration';

// Slim bar shown when a new version of the app has been downloaded. It never
// reloads the page by itself, so nobody loses a note or a video visit mid-way.
const UpdateBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const show = () => setVisible(true);
    window.addEventListener(UPDATE_AVAILABLE_EVENT, show);
    return () => window.removeEventListener(UPDATE_AVAILABLE_EVENT, show);
  }, []);

  if (!visible) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 10000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        padding: '8px 16px',
        backgroundColor: '#D4A017',
        color: '#113F67',
        fontSize: '14px',
        fontWeight: 600,
      }}
    >
      <span>A new version is available. Save your work, then refresh.</span>
      <button
        type="button"
        onClick={applyUpdate}
        style={{
          padding: '4px 14px',
          backgroundColor: '#113F67',
          color: '#FFFFFF',
          border: 'none',
          borderRadius: '6px',
          fontSize: '13px',
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        Refresh now
      </button>
      <button
        type="button"
        onClick={() => setVisible(false)}
        style={{
          padding: '4px 10px',
          backgroundColor: 'transparent',
          color: '#113F67',
          border: '1px solid #113F67',
          borderRadius: '6px',
          fontSize: '13px',
          cursor: 'pointer',
        }}
      >
        Later
      </button>
    </div>
  );
};

export default UpdateBanner;
